
import { logoSize, logoUrl } from '@/utils/images'

export default {
  name: 'BrandLogo',
  props: {
    image: {
      type: Object,
      default: null,
    },
    alt: {
      type: String,
      default: '',
    },
    width: {
      type: Number,
      required: true,
    },
    height: {
      type: Number,
      required: true,
    },
    side: {
      type: Number,
      required: true,
    },
    loading: {
      type: String,
      default: 'lazy',
    },
  },
  data() {
    return {
      ratio: null,
    }
  },
  computed: {
    src() {
      if (!this.image || !this.image.url) return null
      return logoUrl(this.image, this.width, this.height, this.image.extension)
    },
    srcset() {
      if (!this.src) return null
      const double = logoUrl(
        this.image,
        this.width * 2,
        this.height * 2,
        this.image.extension
      )
      return `${this.src} 1x, ${double} 2x`
    },
    logoStyle() {
      const size = logoSize(this.ratio, this.side, this.width, this.height)
      if (!size) return null
      return { width: `${size.width}px`, height: `${size.height}px` }
    },
  },
  watch: {
    src() {
      this.ratio = null
    },
  },
  mounted() {
    const logo = this.$refs.logo
    if (logo && logo.complete) this.measure()
  },
  methods: {
    measure() {
      const logo = this.$refs.logo
      if (!logo || !logo.naturalWidth || !logo.naturalHeight) return
      this.ratio = logo.naturalWidth / logo.naturalHeight
    },
  },
}
